'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  header: '',
  link: 'Clear all',
  footer: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/instantsearch.js/dist-es5-module/src/widgets/clear-all/defaultTemplates.js
// module id = 757
// module chunks = 0